LevelConstants =
  levels:
    'dungeons-of-kithgard': '5411cb3769152f1707be029c'
    'defense-of-plainswood': '541b67f71ccc8eaae19f3c62'

  lowerIsBetterScoreTypes: ['time', 'damage-taken', 'code-length']

module.exports = LevelConstants



// WEBPACK FOOTER //
// ./app/lib/LevelConstants.coffee